<div class="filter-editor no-field-space" *ngIf="filter">
  <sc-flex vertical stretchContent fitHeight>
    <div class="filter-top-toolbar">
      <div class="toolbar-layout">
        <sc-flex>
          <sc-cancel-button (click)="cancel()" [disabled]="!this.filter.dirty"></sc-cancel-button>
          <sc-content-spacer></sc-content-spacer>
          <sc-save-button primary (click)="save()" [disabled]="!isSaveEnabled"></sc-save-button>
        </sc-flex>
      </div>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
    <div class="filter-details">
      <sc-flex>
        <sc-dictionary-field [model]="filter.name" [defaultLabel]="'name'" grow
          (dictionaryChanged)="displayPropertyChanged()" [labelDictionaryKey]="'tmc-yard.common.name'" [required]="true"
          [maxlength]="255">
        </sc-dictionary-field>
        <sc-content-spacer></sc-content-spacer>
        <mat-checkbox class="form-checkbox" [(ngModel)]="filter.displayOnly" (ngModelChange)="displayPropertyChanged()">
          <sc-dictionary-label
            dictionaryKey="tmc-yard.ui.admin.filter-administration.filter-editor.display-only"></sc-dictionary-label>
        </mat-checkbox>
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-dictionary-label
        dictionaryKey="tmc-yard.ui.admin.filter-administration.filter-editor.visible-table-columns"></sc-dictionary-label>
      <app-table-column-editor class="long-field" (columnsChanged)="tableColumnsChanged($event)"
        [setMode]="columnEditorMode" [columns]="filter.tableColumns"></app-table-column-editor>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex>
        <mat-form-field class="flex-grow margin-right field" appearance="fill">
          <mat-label>
            <sc-dictionary-label
              dictionaryKey="tmc-yard.ui.admin.filter-administration.filter-editor.sort-column"></sc-dictionary-label>
          </mat-label>
          <mat-select [(ngModel)]="filter.sortColumn" (ngModelChange)="displayPropertyChanged()">
            <mat-option [value]="''">
              <sc-dictionary-label
                dictionaryKey="tmc-yard.ui.admin.filter-administration.filter-editor.sort-column.none"></sc-dictionary-label>
            </mat-option>
            <mat-option [value]="c.key" *ngFor="let c of tableColumns">
              <sc-dictionary-label [dictionaryKey]="c.dictionaryKey"></sc-dictionary-label>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <sc-content-spacer></sc-content-spacer>
        <mat-checkbox class="form-checkbox" [(ngModel)]="filter.sortDescending"
          (ngModelChange)="displayPropertyChanged()">
          <sc-dictionary-label
            dictionaryKey="tmc-yard.ui.admin.filter-administration.filter-editor.sort-descending"></sc-dictionary-label>
        </mat-checkbox>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-dictionary-label dictionaryKey="tmc-common.filter-administration.ui.mail-scheduling"></sc-dictionary-label>
        <sc-action-icon iconClass="fa-rotate-right" (click)="editMailSchudles()"
          [iconStyle]="this.filter?.filterMailSchedules?.length > 0 ? 'value' : 'no-value'"></sc-action-icon>
      </sc-flex>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <app-node-editor [setfilterAdministrationContext]="filterAdministrationContext" [setNode]="filter.rootNode">
        </app-node-editor>
      </sc-scroll-pane>
    </sc-flex-fitting-content>

  </sc-flex>
</div>
